import { useCallback } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';

import { useUpdateFamilyTreeSettingsMutation } from '../graphql/FamilyTreeMutations.generated';
import { FamilyTreeEffectFn, SaveNodePositionsEffect } from '../types';

export function useSaveNodePositionsEffect(): FamilyTreeEffectFn<SaveNodePositionsEffect> {
  const { reportError } = useReportError();
  const { showFeedback } = useFeedback();

  const [updateFamilyTreeSettings] = useUpdateFamilyTreeSettingsMutation({
    onError: (error: Error) => {
      showFeedback(
        'Unable to save family tree node positions. Please try again.'
      );
      reportError('Error saving family tree node positions', error);
    },
  });

  return useCallback<FamilyTreeEffectFn<SaveNodePositionsEffect>>(
    (_state, effect, _dispatch) => {
      void updateFamilyTreeSettings({
        variables: {
          householdId: effect.householdId,
          settings: {
            nodeConfigurations: effect.nodeConfigurations,
          },
        },
      });
    },
    [updateFamilyTreeSettings]
  );
}
